import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Phone, MapPin, Sun, Moon } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Meals from "./Meals";
import Delivery from "./Delivery";
import EnqForm from "../components/model/EnqForm";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProvidersDetails } from "../redux/Thunk/providerThunk";
import HomeShimmer from "../components/Shimmer/HomeShimmer";
import MealShimmer from "../components/Shimmer/MealShimmer";
import DeliverShimmer from "../components/Shimmer/DeliverShimmer";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const Home = () => {
  const navigate = useNavigate();
  const { provider } = useParams();
  const location = useLocation();
  // console.log("the provider is :", provider);
  const dispatch = useDispatch();
  const { data, isProviderLoading, error } = useSelector(
    (state) => state.providers,
  );
  const [Curr, setCurr] = useState("");
  useEffect(() => {
    if (!provider) return;

    // ✅ if format valid → call API
    dispatch(
      getProvidersDetails({
        provider: provider,
        deviceType: 2,
      }),
    )
      .unwrap()
      .then((res) => {
        // console.log("The res is :", res.data);
        setCurr(res.data?.currency_symbol);
      })
      .catch(() => {
        navigate("/not-found", { replace: true });
      });
  }, [provider, dispatch, navigate]);

  // FOR NOT FOUND PAGE
  //   useEffect(() => {
  //   if (!provider) return;

  //   // ✅ ONLY allow ttspin IDs
  //   const isValid = provider.toLowerCase().startsWith("ttspin");

  //   if (!isValid) {
  //     navigate("/not-found", { replace: true });
  //     return;
  //   }

  //   // ✅ API call
  //   dispatch(
  //     getProvidersDetails({
  //       provider: provider,
  //       deviceType: 2,
  //     })
  //   )
  //     .unwrap()
  //     .then((res) => {
  //       setCurr(res.data?.currency_symbol);
  //     })
  //     .catch(() => {
  //       navigate("/not-found", { replace: true });
  //     });
  // }, [provider]);

  // FOR CONVERTING THE ID INTO NAME (USE IF NEEDED BUT THE ISSUE WILL OCCUR AT TIME OF SHARED LINK SHARING BECAUSE ADDRESSBAR COPIES WHAT IS THERE IN BAR)
  // useEffect(() => {
  //   if (!provider) return;

  //   const searchParams = new URLSearchParams(location.search);
  //   const idFromQuery = searchParams.get("id");

  //   // 🔥 Decide actual ID
  //   let actualId = provider;

  //   // If URL is slug → get ID from query
  //   if (!provider.startsWith("ttspin")) {
  //     if (!idFromQuery) {
  //       navigate("/not-found", { replace: true });
  //       return;
  //     }
  //     actualId = idFromQuery;
  //   }

  //   // ✅ Call API with correct ID
  //   dispatch(
  //     getProvidersDetails({
  //       provider: actualId,
  //       deviceType: 2,
  //     }),
  //   )
  //     .unwrap()
  //     .then((res) => {
  //       const data = res.data;
  //       setCurr(data?.currency_symbol);

  //       // 🔥 Create slug
  //       const slug = data.owner?.name
  //         ?.toLowerCase()
  //         .replace(/\s+/g, "-")
  //         .replace(/[^\w-]/g, "");

  //       // 🔥 Replace URL ONLY if needed
  //       const newUrl = `/${slug}?id=${actualId}`;

  //       if (location.pathname + location.search !== newUrl) {
  //         navigate(newUrl, { replace: true });
  //       }
  //     })
  //     .catch(() => {
  //       navigate("/not-found", { replace: true });
  //     });
  // }, [provider, location.search, dispatch, navigate]);

  const images = data?.service_other_images
    ? [...data.service_other_images].sort(
        (a, b) => b.is_cover_image - a.is_cover_image,
      )
    : [];

  const [index, setIndex] = useState(0);
  const [enquiry, setEnquiry] = useState(false);
  const prevSlide = () => {
    if (index > 0) setIndex(index - 1);
  };

  const nextSlide = () => {
    if (index < images.length - 1) setIndex(index + 1);
  };

  const getInitials = (name = "") => {
    const safeName = typeof name === "string" ? name : "";
    const words = safeName.trim().split(" ").filter(Boolean);

    if (words.length === 0) {
      return "";
    }

    if (words.length === 1) {
      // Take first 2 letters of single word
      return words[0].slice(0, 2).toUpperCase();
    }

    // If 2 or more words → take first letter of first 2 words
    return (words[0][0] + words[1][0]).toUpperCase();
  };

  const to12Hour = (time24) => {
    if (!time24) return "";

    const [hourStr, minute] = time24.split(":");
    let hour = Number(hourStr);

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // 0 → 12

    return `${hour}:${minute} ${ampm}`;
  };

  useEffect(() => {
    if (images.length > 0) {
      setIndex(0); // reset to first image on new data
    }
  }, [images.length]);

  return (
    <>
      <Header />

      {isProviderLoading ? (
        <>
          <HomeShimmer />
          <MealShimmer />
          <DeliverShimmer />
        </>
      ) : (
        <>
          {data && (
            <section className="font-poppins subpixel-antialiased">
              <div className="bg-[#ffa194]/5 background">
                <div className="w-full md:max-w-7xl mx-auto px-6 lg:px-8 xl:py-14">
                  {/* FLEX WRAPPER */}
                  <div className="flex flex-col md:flex-row justify-center md:justify-between gap-16">
                    {/* CONTENT — small screens first, large screens right */}
                    <div className="order-1 lg:order-2 flex flex-col gap-4 max-w-2xl pt-6">
                      <div className="w-full max-w-full sm:max-w-[95%] md:max-w-[90%] lg:max-w-[80%] ">
                        {/* Service Name */}
                        <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-bold text-orange leading-snug font-outfit break-words">
                          {data.service_name}
                        </h1>

                        {/* Service Description */}
                        <p className="text-xs sm:text-sm md:text-base text-gray-500 font-normal leading-relaxed break-words mt-2">
                          {data.service_description}
                        </p>
                      </div>

                      {/* Owner Info */}
                      <div className="flex gap-5 ">
                        <div className="shrink-0">
                          <div className="w-12 h-12 rounded-full bg-[#FFE6DF] border border-[#FFD1C5] text-orange font-bold flex text-center font-outfit justify-center items-center">
                            {getInitials(data.owner?.name)}
                          </div>
                        </div>

                        <div className="flex flex-col gap-1">
                          <h3 className="font-semibold text-[#191919] text-base xl:text-xl">
                            {data.owner?.name}
                          </h3>
                          <div className="flex justify-between flex-wrap gap-4 text-xs xl:text-sm text-[#191919]">
                            <span className="flex items-center gap-1 ">
                              <Phone size={14} />+{data.owner?.country_code}{" "}
                              {data.owner?.contact_no}
                            </span>
                            <span className="inline-flex items-center gap-2 bg-gray-100/50 px-3 py-1 rounded-xl shadow-sm text-sm">
                              <MapPin size={16} className="text-orange-500" />
                              <span className="font-semibold text-gray-500 truncate">
                                {data.delivery?.city}
                              </span>
                              <span className="text-gray-800 font-bold truncate">
                                , {data.delivery?.country}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Timing Cards */}
                      <div className="mt-3">
                        <div className="flex flex-row gap-4 md:gap-6 border border-[#FECDC1] rounded-2xl bg-white p-4 w-full md:w-96">
                          {/* Card 1: Lunch */}
                          <div className="flex flex-col gap-1 flex-1 space-y-2">
                            <div className="flex items-center gap-1 font-semibold text-orange text-lg">
                              <Sun size={20} /> Lunch
                            </div>
                            <p className="text-xs text-[#191919]">
                              {to12Hour(data.lunch_time_from)} to{" "}
                              {to12Hour(data.lunch_time_to)}
                            </p>
                          </div>

                          {/* Divider */}
                          <div className="w-px bg-[#FECDC1]" />

                          {/* Card 2: Dinner */}
                          <div className="flex flex-col gap-1 flex-1 space-y-2">
                            <div className="flex items-center gap-1 font-semibold text-orange text-lg">
                              <Moon size={20} /> Dinner
                            </div>
                            <p className="text-xs text-[#191919]">
                              {to12Hour(data.dinner_time_from)} to{" "}
                              {to12Hour(data.dinner_time_to)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* SLIDER — small screens second, large screens left */}
                    <div className="order-2 lg:order-1 relative w-full p-4 max-w-[380px] h-[440px]">
                      <div className="relative w-full aspect-square">
                        {/* Back Frame */}
                        <div className="absolute inset-0 border-[20px] border-[#E55D3B] bg-white" />

                        {/* Front Frame */}
                        <div className="absolute inset-0 rotate-6 border-[12px] border-[#E55D3B] bg-white overflow-hidden">
                          {images.length > 0 && (
                            <img
                              key={index}
                              src={images[index]?.image_url}
                              alt="service"
                              className="w-full h-full object-cover block animate-fadeSlide"
                            />
                          )}
                        </div>
                      </div>

                      {/* ARROWS */}
                      <div className="flex justify-center gap-8 mt-8">
                        <button
                          onClick={prevSlide}
                          disabled={index === 0}
                          className={`p-2 rounded-full transition ${
                            index === 0
                              ? "opacity-40 cursor-not-allowed"
                              : "hover:bg-orange/10"
                          }`}
                        >
                          <ArrowLeft size={24} className="text-orange" />
                        </button>

                        <button
                          onClick={nextSlide}
                          disabled={index === images.length - 1}
                          className={`p-2 rounded-full transition ${
                            index === images.length - 1
                              ? "opacity-40 cursor-not-allowed"
                              : "hover:bg-orange/10"
                          }`}
                        >
                          <ArrowRight size={24} className="text-orange" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Meals */}
              <div className="flex justify-center">
                <Meals meals={data} />
              </div>

              {/* Delivery info */}
              <Delivery deliveryData={data.delivery} currencySymbol={Curr} />
            </section>
          )}
        </>
      )}

      {/* Footer */}
      <Footer />

      {!isProviderLoading && (
        <button
          className="
    fixed bottom-20 lg:bottom-8 right-8  
    bg-gradient-to-r from-orange-400 to-orange-600 
    text-white font-semibold 
    px-6 py-3 rounded-full 
    shadow-xl   hover:shadow-2xl 
    transition transform duration-300 
    animate-none md:animate-pulse
    z-40
  "
          onClick={() => setEnquiry(true)}
        >
          Inquiry Now
        </button>
      )}

      {enquiry && (
        <div>
          <GoogleReCaptchaProvider
            reCaptchaKey="6Le-uj8gAAAAABNGm_JUwhAy3BpxVjzGs5duNbjU"
            scriptProps={{
              async: true,
              defer: true,
              appendTo: "body",
            }}
          >
            <EnqForm onClose={() => setEnquiry(false)} mealsData={data.meals} />
          </GoogleReCaptchaProvider>
        </div>
      )}
    </>
  );
};

export default Home;
